import {initWebComponent} from "@/helpers/web-component-helper";
import {addLayer, getLayerByName} from "@/helpers/ol/ol-layer-helper";
import {toggleGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";

export class LayerInfoInfoItemGeometryComponent extends HTMLElement {
    constructor(){
        super();

        const formID = this.getAttribute('data-form-id')
        const index = this.getAttribute('data-index')
        const checked = this.getAttribute('data-checked')

        const template = document.createElement('template');

        let checkedElement = ''
        if(checked === 'true') {
            checkedElement = 'checked="checked"'
        }

        template.innerHTML = `<label class="switcher mr-1 popper-header">
                    <input type="checkbox" class="switcher-input" ` + checkedElement + `>
                     <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                     Toon/verberg object in de kaart
                    <div class="arrow" data-popper-arrow=""></div>
                  </div>
                    <span class="switcher-indicator">
                      <span class="switcher-yes">
                        <span class="fa fa-draw-polygon"></span>
                      </span>
                      <span class="switcher-no">
                        <span class="fa fa-times"></span>
                      </span>
                    </span>
                  </label>`

        initWebComponent(this, template)

        this.addEventListener('change', () => {

            toggleGeoJsonLayer(formID, index)
        })
    }
}

